import PropTypes from "prop-types";
import React from "react";

import lineStyles from "../../constants/lineStyles";
import { PropTypeShapes } from "../../types";

const MindmapConnectorDot = props => {
  let radius = props.lineStyle == lineStyles.THICK ? 4 : 3;
  const left = props.point.x - radius;
  const top = props.point.y - radius;
  const size = radius * 1;

  return (
    <svg
      className={`mindmapConnectorDot ${props.color} ${props.selected ? "selected" : ""}`}
      style={{
        transform: `translate(${left}px,${top}px)`,
        width: `${size}px`,
        height: `${size}px`,
        opacity: props.isFiltered ? 0.4 : 1
      }}
    >
      <circle r={radius} cx={radius} cy={radius} fill="currentColor" stroke="none" />
    </svg>
  );
};

MindmapConnectorDot.propTypes = {
  id: PropTypes.string.isRequired,
  color: PropTypes.string.isRequired,
  lineStyle: PropTypes.string.isRequired,
  point: PropTypeShapes.point,
  selected: PropTypes.bool.isRequired,
  isFiltered: PropTypes.bool
};

export default MindmapConnectorDot;
